export enum MenuState {
  Main = 'Main',
  Machines = 'Machines',
  MachineSelected = 'Machine-Selected',
  SelectMission = 'Select-Mission',
  SelectJob = 'Select-Job',
  SelectField = 'Select-Field',
  StartJob = 'Start-Job',
  ResumeJob = 'Resume-Job',
  MonitorJob = 'Monitor-Job'
}
